import React, {Dispatch, SetStateAction, useState} from "react";
import {TimeZoneFilter} from "@lib/training/time-zone-filter";
import {TableOfContents} from "@components/table-of-contents";
import Page from "@components/page";
import StandardLayout from "@components/layout/standard-layout";
import {Checkbox, Container, FormControl, FormControlLabel, FormGroup, FormLabel} from "@mui/material";
import {CourseSchedule} from "@components/training/course-schedule";
import {CourseWithSessions} from "@lib/talentlms/talentlms-utils";

export type TrainingSchedulePageProps = {
    schedules: CourseWithSessions[]
}

export const TrainingSchedulePage = ({schedules}: TrainingSchedulePageProps) => {
    const [timeZoneFilter, setTimeZoneFilter] = useState<TimeZoneFilter>({
        'Europe/Prague': true,
        'America/Chicago': true,
    })
    const controls = schedules.length > 1 && (
        <>
            <TableOfContents dependencies={[]}/>
            {/*<Box my={4}>*/}
            {/*    <Control timeZoneFilter={timeZoneFilter} setTimeZoneFilter={setTimeZoneFilter}/>*/}
            {/*</Box>*/}
        </>
    )
    return (
        <Page name={'Training Schedule'}>
            <StandardLayout title='Training Schedule'
                            rightDrawerContent={controls}
            >
                <Container maxWidth='sm'>
                    {/*<Box my={4}>*/}
                    {/*    <Typography variant='h1'>Public Training Schedule</Typography>*/}
                    {/*</Box>*/}
                    {
                        schedules.map(courseWithSessions => (
                            <CourseSchedule
                                key={courseWithSessions.course.id}
                                course={courseWithSessions.course}
                                iltSessions={courseWithSessions.iltSessions}
                                timeZoneFilter={timeZoneFilter}
                            />
                        ))
                    }
                </Container>
            </StandardLayout>
        </Page>
    )
}

const Control = ({
                     timeZoneFilter,
                     setTimeZoneFilter,
                 }: { timeZoneFilter: TimeZoneFilter, setTimeZoneFilter: Dispatch<SetStateAction<TimeZoneFilter>> }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTimeZoneFilter({...timeZoneFilter, [event.target.name]: event.target.checked});
    };
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">Filter time zone</FormLabel>
            <FormGroup row>
                <FormControlLabel
                    control={<Checkbox checked={timeZoneFilter["Europe/Prague"]} onChange={handleChange}
                                       name="Europe/Prague"/>}
                    label="Europe/Prague"
                />
                <FormControlLabel
                    control={<Checkbox checked={timeZoneFilter["America/Chicago"]} onChange={handleChange}
                                       name="America/Chicago"/>}
                    label="America/Chicago"
                />
            </FormGroup>
        </FormControl>
    )
}
